// rgba(225, 245, 255, 1)

import { makeThemedStyles } from "@qpr/client-api-base/viewcomponents/utils";
import React from "react";

const usePerspectiveChipStyles = makeThemedStyles(
  "PerspectiveChip",
  (theme) => ({
    root: {
      height: "1.916em",
      background: " rgba(22, 40, 112, 0.1)",
      color: "rgba(22, 40, 112, 1)",
      borderRadius: "1.25em",
      fontWeight: 500,
      fontSize: "1.2em",
      lineHeight: "1.25em",
      padding: "0.33em 1.33em",
      maxWidth: "8.666em",
    },
  })
);

const PerspectiveChip = (props: React.PropsWithChildren<{}>) => {
  const styles = usePerspectiveChipStyles();
  return <div className={styles.root}>{props.children}</div>;
};

export default PerspectiveChip;
